<style scoped="scoped" lang="scss">
.org-chart-node-label-inner {
  font-size: 23px !important; // 设置树的默认字体
}

/* 设置树宽度 */
.org-chart-container {
  padding: 80px;
  display: flex;
  justify-content: center;
  // width: 1300px !important;
  // height: 630px !important;
  // display: flex !important;
  // align-items: center !important;
  // overflow: auto;
  // scrollbar-color: #515151 rgba(0, 0, 0, 0.1);
  // /* 第一个方块颜色，第二个轨道颜色(用于更改火狐浏览器样式) */
  // scrollbar-width: thin;
}

.my-selecting {
  color: red !important;
}
</style>
<style lang="scss">
.label-class-blue {
  color: #1989fa;
}

.label-bg-blue {
  background: #1989fa;
  color: #fff;
}
</style>

<template>
  <div class="dialog-scroller">
    <div style="display: inline;">
      <yi_curd_table v-show="false" v-bind="$attrs" :name="$options.name" ref="yt"></yi_curd_table>
      <div>
        <el-form size="mini" :inline="true" :model="yt.editObj" class="demo-form-inline">
          <el-form-item class="noborder" :label="$t('gongyiluxianbianma')">
            <el-input disabled v-model="$attrs.craftProcess.code"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('gongyiluxianmingcheng')">
            <el-input disabled v-model="$attrs.craftProcess.name"></el-input>
          </el-form-item>
          <el-form-item v-if="flows.length == 0" :label="$t('diyigejiedian')">
            <el-select filterable :clearable="true" v-model="yt.editObj.workProcedureId">
              <el-option v-for="(item, index) in nodeList" :key="index" :label="item.workName" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="!flows.length > 0" style="display: flex;justify-content: center;">
            <el-empty :image-size="200"></el-empty>
          </el-form-item>
        </el-form>
        <span v-if="!flows.length > 0" class="dialog-footer" style="display: flex;justify-content: flex-end;margin-top: 60px;">
          <el-button :loading="yt.editObj.loading" size="mini" @click="saveNode" type="primary">
            {{ $t('baocun/genggai') }}
          </el-button>
        </span>
      </div>
      <div style="overflow: auto;height: 400px;margin-top: 10px">
        <div id="web_base_craft_flow" :style="{ height: flow2Height + 'px', width: flow1Width + 'px' }"></div>
      </div>
      <!-- 增加下一级 -->
      <el-drawer :modal="false" :visible.sync="addDrawer" :direction="direction" :with-header="false" :size="208" :show-close="true">
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <p style="color: #303133;padding: 20px 0px 10px 40px;font-size: 18px;">{{ $t('xinzeng') }}</p>
          <el-button type="text" @click="closeAddDrawer()" class="el-icon-close" style="margin-right: 40px;"> </el-button>
        </div>
        <div style="margin-left: 156px;">
          <el-form size="mini" :inline="true" :model="yt.editObj" class="demo-form-inline">
            <el-form-item :label="$t('shangdaogongxubianma/miaoshu')">
              <el-select multiple filterable :clearable="true" v-model="yt.editObj.procedureIds">
                <el-option v-for="(item, index) in nodeList2" :key="index" :label="item.codeAndDesc" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('xinzengjiediangongxubianma/miaoshu')" required>
              <el-select filterable :clearable="true" v-model="yt.editObj.workProcedureIds">
                <el-option v-for="(item, index) in nodeList" :key="index" :label="item.workName" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('shunxu')" required>
              <el-input v-model="yt.editObj.prioritys"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shifoubaogong')" required>
              <el-select v-model="yt.editObj.whetherJobBooking" @change="$forceUpdate()">
                <el-option :label="$t('shi')" :value="true"></el-option>
                <el-option :label="$t('fou')" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('shifoushengchengdairukudan')" required>
              <el-select v-model="yt.editObj.generateInOrder" @change="$forceUpdate()">
                <el-option :label="$t('shi')" :value="true"></el-option>
                <el-option :label="$t('fou')" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div style="display: flex;justify-content: flex-end;padding-right: 50px;">
            <el-button size="mini" @click="addDrawer = false">
              {{ $t('quxiao') }}
            </el-button>
            <el-button :loading="yt.editObj.loading" size="mini" @click="addOrg()" type="primary">
              {{ $t('baocun') }}
            </el-button>
          </div>
        </div>
      </el-drawer>
      <!-- 编 -->
      <el-drawer :modal="false" :visible.sync="updateDrawer" :direction="direction" :with-header="false" :size="208" :show-close="true">
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <p style="color: #303133;padding: 20px 0px 10px 40px;font-size: 18px;">{{ $t('bianji') }}</p>
          <el-button type="text" @click="closeUpdateDrawer()" class="el-icon-close" style="margin-right: 40px;"> </el-button>
        </div>
        <div style="margin-left: 156px;">
          <el-form :model="yt.editObj" size="mini" :inline="true" class="demo-form-inline">
            <el-form-item :label="$t('shangdaogongxubianma/miaoshu')">
              <el-select multiple filterable :clearable="true" v-model="yt.editObj.procedureIds">
                <el-option v-for="(item, index) in nodeList2" :key="index" :label="item.codeAndDesc" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('xuanzhongjiediangongxubianma/miaoshu')" required>
              <el-select filterable :clearable="true" v-model="yt.editObj.workProcedureId">
                <el-option v-for="(item, index) in nodeList" :key="index" :label="item.workName" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('shunxu')" required>
              <el-input v-model="yt.editObj.priority"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shifoubaogong')" required>
              <el-select v-model="yt.editObj.whetherJobBooking" @change="$forceUpdate()">
                <el-option :label="$t('shi')" :value="true"></el-option>
                <el-option :label="$t('fou')" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('shifoushengchengdairukudan')" required>
              <el-select v-model="yt.editObj.generateInOrder" @change="$forceUpdate()">
                <el-option :label="$t('shi')" :value="true"></el-option>
                <el-option :label="$t('fou')" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div style="display: flex;justify-content: flex-end;padding-right: 50px;">
            <el-button size="mini" @click="updateDrawer = false">
              {{ $t('quxiao') }}
            </el-button>
            <el-button :loading="yt.editObj.loading" size="mini" @click="updateOrg()" type="primary">
              {{ $t('baocun') }}
            </el-button>
          </div>
        </div>
      </el-drawer>
    </div>
    <div style="display: flex;justify-content: flex-end;margin-bottom: 10px;margin-top: 10px">
      <template>
        <span v-if="flows.length > 0" slot="footer" class="dialog-footer">
          <el-button size="mini" @click="openDeleteMessageBox()">{{ $t('shanchucijiedian') }}</el-button>
          <el-button size="mini" @click="openUpdateDrawer" type="primary" plain>{{ $t('bainjicijiedian') }} </el-button>
          <el-button size="mini" @click="openAddDrawer" type="primary">
            {{ $t('zengjiaxiayiji') }}
          </el-button>
        </span>
      </template>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_base_craft_architecture',
  components: {},
  data() {
    return {
      titleBarWidth: 0,
      key: 0,
      editConditions: {
        priority: ''
      },
      flow2Height: 10,
      flow1Width: 10,
      drawer: false,
      direction: 'btt',
      addDrawer: false,
      updateDrawer: false,
      graph: null,
      currentNode: null,
      selectParentIds: null,
      priority: null,
      routeList: [],
      nodeList: [],
      nodeList2: [],
      flows: [],
      currentNodeId: null,
      allNode: [],
      firstNode: {}
    };
  },
  watch: {
    addDrawer: {
      handler(n) {
        if ((n = false)) {
          this.yt.editObj.workProcedureIds = [];
        }
      },
      immediate: false,
      deep: true
    }
  },
  created() {
    this.getNodeList();
    this.getNodeList2();
    this.utils.event_hub.$on('node1Tap', this.node1Tap);
    setTimeout(() => {
      this.queryWorkProcedure();
    }, 300);
  },
  methods: {
    openAddDrawer() {
      this.setDefaultValue();
      this.$set(this.yt.editObj, 'workProcedureIds', []);
      this.$set(this.yt.editObj, 'prioritys', undefined);
      if (this.currentNodeId) {
        this.addDrawer = true;
      } else {
        this.utils.errorMessage(this.$t('qingxuanzexinzengjiedian'));
        return false;
      }
      this.getNodeList();
      this.getNodeList2();
      if (this.allNode.length > 1) {
        if (this.currentNodeId != this.firstNode['id']) {
          this.$set(this.yt.editObj, 'procedureIds', [this.currentNodeId]);
        } else {
          this.$set(this.yt.editObj, 'procedureIds', []);
        }
      } else {
        this.$set(this.yt.editObj, 'procedureIds', [this.currentNodeId]);
      }
    },
    openUpdateDrawer() {
      if (this.currentNodeId) {
        this.updateDrawer = true;
        this.queryWorkProcedure();
      } else {
        this.utils.errorMessage(this.$t('qingxuanzeyaobianjidejiedian'));
        return false;
      }
      this.getNodeList();
      this.getNodeList2();
      this.yt.editObj = this.currentNode;
      if (this.allNode.length > 1) {
        if (this.currentNodeId != this.firstNode['id']) {
          this.yt.editObj.procedureIds = this.currentNode['parentIds'];
          var arr = this.currentNode['parentIds'].split(',').map(Number);
          this.$set(this.yt.editObj, 'procedureIds', arr);
        } else {
          this.$set(this.yt.editObj, 'procedureIds', []);
        }
      } else {
        this.$set(this.yt.editObj, 'procedureIds', []);
      }
    },
    node1Tap(params) {
      console.log('select', params);
      const nodes = this.graph.getNodes();
      if (nodes.length) {
        this.allNode = nodes;
        this.firstNode = nodes[0];
        this.currentNode = params.item;
        nodes.forEach(node => {
          node.setData({
            currentNodeId: this.currentNode.id
          });
        });
        this.currentNodeId = this.currentNode.id;
      }
    },
    setDefaultValue() {
      this.yt.editObj.whetherJobBooking = true;
      this.yt.editObj.generateInOrder = true;
    },
    closeAddDrawer() {
      // this.setDefaultValue()
      this.addDrawer = false;
    },
    closeUpdateDrawer() {
      this.updateDrawer = false;
    },
    openDeleteMessageBox() {
      if (this.currentNodeId) {
        this.$confirm(this.$t('shanchujiangbukehuifu,shifoujixu?'), this.$t('jinggao'), {
          confirmButtonText: this.$t('shanchu'),
          cancelButtonText: this.$t('quxiao'),
          type: 'warning',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;
              setTimeout(() => {
                done();
                setTimeout(() => {
                  instance.confirmButtonLoading = false;
                }, 300);
              }, 3000);
            } else {
              done();
            }
          }
        })
          .then(() => {
            this.deleteOrg();
          })
          .catch(() => {});
      } else {
        this.utils.errorMessage(this.$t('qingxuanzeyaoshanchudejiedian'));
      }
    },
    saveNode() {
      let params = {
        workProcedureId: this.yt.editObj.workProcedureId,
        whetherJobBooking: this.yt.editObj.whetherJobBooking != undefined ? this.yt.editObj.whetherJobBooking : true,
        parentIds: '',
        processRouteId: this.$attrs.craftProcess.id,
        priority: 1,
        generateInOrder: true
      };
      this.yt.editObj.loading = true;
      this.http
        .post('/web/craft/basic/process/route/createWorkProcedure', params)
        .then(res => {
          let refresh = this.queryWorkProcedure();
          if (refresh) {
            this.utils.successMessage(this.$t(res.msg));
          }
          this.addDrawer = false;
        })
        .catch(error => {
          this.utils.errorMessage(this.$t(error));
        })
        .finally(() => {
          this.yt.editObj.loading = false;
        });
    },
    addOrg() {
      let params = {
        parentIds: this.currentNode.id,
        workProcedureId: this.yt.editObj.workProcedureIds,
        processRouteId: this.$attrs.craftProcess.id,
        priority: this.yt.editObj.prioritys,
        procedureIds: this.yt.editObj.procedureIds,
        whetherJobBooking: this.yt.editObj.whetherJobBooking,
        generateInOrder: this.yt.editObj.generateInOrder
      };
      this.yt.editObj.loading = true;
      this.http
        .post('/web/craft/basic/process/route/createWorkProcedure', params)
        .then(res => {
          let refresh = this.queryWorkProcedure();
          if (refresh) {
            this.utils.successMessage(this.$t(res.msg));
          }
          this.queryWorkProcedure();
          this.addDrawer = false;
        })
        .catch(error => {
          this.utils.errorMessage(this.$t(error));
        })
        .finally(() => {
          this.yt.editObj.loading = false;
        });
    },
    updateOrg() {
      let params = {
        ...this.yt.editObj
      };
      this.yt.editObj.loading = true;
      this.http
        .post('/web/craft/basic/process/route/updateWorkProcedure', params)
        .then(res => {
          let refresh = this.queryWorkProcedure();
          if (refresh) {
            this.utils.successMessage(this.$t(res.msg));
          }
          this.queryWorkProcedure();
          this.updateDrawer = false;
          // this.yt.editObj.workProcedureId=''
        })
        .catch(error => {
          this.utils.errorMessage(this.$t(error));
        })
        .finally(() => {
          this.yt.editObj.loading = false;
        });
    },
    deleteOrg() {
      let params = {
        id: this.currentNode.id
      };
      this.yt.editObj.loading = true;
      this.http
        .post('/web/craft/basic/process/route/deleteWorkProcedure', params)
        .then(res => {
          let refresh = this.queryWorkProcedure();
          if (refresh) {
            this.queryWorkProcedure();
            this.utils.successMessage(this.$t(res.msg));
          }
          this.$nextTick(async () => {
            await this.queryWorkProcedure();
          });
          this.yt.editObj.workProcedureIds = [];
        })
        .catch(error => {
          this.utils.errorMessage(this.$t(error));
        })
        .finally(() => {
          this.yt.editObj.loading = false;
        });
    },
    initFlow(nodes, edges) {
      this.graph = new this.x6({
        container: document.getElementById('web_base_craft_flow'),
        width: 'auto',
        height: 'auto',
        grid: false,
        interacting: {
          nodeMovable: false
        }
      });

      const model = {
        nodes: nodes,
        // nodes: [nodes[0]],
        edges: edges
      };
      const dagreLayout = new this.x6layout({
        type: 'dagre',
        rankdir: 'LR',
        align: 'UL',
        ranksep: 40,
        nodesep: 20,
        controlPoints: true
      });
      const newModel = dagreLayout.layout(model);
      this.graph.fromJSON(newModel);
      this.countFlow2Heihgt();
    },
    countFlow2Heihgt() {
      setTimeout(() => {
        let id = 'web_base_craft_flow';
        this.flow2Height = document
          .getElementById(id)
          .getElementsByClassName('x6-graph-svg-viewport')[0]
          .getBoundingClientRect().right;
        this.flow1Width =
          document
            .getElementById(id)
            .getElementsByClassName('x6-graph-svg-viewport')[0]
            .getBoundingClientRect().width + 120;
      }, 600);

      console.log('getBoundingClientRect', this.flow2Height);
    },
    queryWorkProcedure() {
      this.http
        .get('web/craft/basic/process/route/queryWorkProcedure', {
          params: {
            processRouteId: this.$attrs.craftProcess.id
          }
        })
        .then(res => {
          if (res.data.length === 1) {
            // res.data[0]['parentIds'] = String(res.data[0]['id'])
            res.data[0]['procedureIds'] = [res.data[0]['id']];
          }
          this.flows = res.data;
          console.log('flowsflows', this.flows);

          let nodeName = '';
          let processName = '';
          for (let i = 0; i < this.flows.length; i++) {
            this.flows[i].nodeName = this.flows[i]['workProcedureCode'] + '/' + this.flows[i]['workProcedureDesc'];
            this.flows[i].processName = this.flows[i]['workProcedureCode'] + '/' + this.flows[i]['workProcedureDesc'];
          }
          let nodes = res.data.map(item => {
            return {
              id: item.id + '',
              shape: 'node1',
              width: 110,
              height: 40,
              data: {
                id: 'web_base_craft_flow' + '_' + item.id,
                priority: item.priority,
                item: JSON.parse(JSON.stringify(item))
              }
            };
          });
          // work_order_execution_list
          let edges = [];
          for (var i = 0; i < res.data.length; i++) {
            let node = res.data[i];
            if (res.data[i].parentIds == '') {
              continue;
            }
            let parentIdArr = res.data[i].parentIds.split(',');
            for (var j = 0; j < parentIdArr.length; j++) {
              edges.push({
                source: parentIdArr[j],
                target: node.id + '',
                router: {
                  name: 'manhattan',
                  startDirections: ['right'],
                  endDirections: ['left']
                }
              });
            }
          }

          this.initFlow(nodes, edges);
          this.countFlow2Heihgt();
        });
    },
    getNodeList() {
      this.http
        .get('/web/craft/basic/process/route/getWorkProcedureList', {
          params: {
            pageNum: 1,
            pageSize: 999,
            routeId: this.$attrs.craftProcess.id
          }
        })
        .then(res => {
          this.nodeList2 = res.data;
          console.log('nodeList2', this.nodeList2);
        });
    },
    getNodeList2() {
      this.http
        .get('/web/craft/basic/work/procedure/page', {
          params: {
            pageNum: 1,
            pageSize: 999
          }
        })
        .then(res => {
          this.nodeList = res.data.rows;
          let workName = '';
          for (let i = 0; i < this.nodeList.length; i++) {
            this.nodeList[i].workName = this.nodeList[i]['code'] + '/' + this.nodeList[i]['desc'];
          }
        });
    }
    // add() {
    // 	const nodes = graph.getNodes();
    // 	if (nodes.length) {
    // 		nodes.forEach((node) => {
    // 			const {
    // 				num
    // 			} = node.getData();
    // 			node.setData({
    // 				num: num + 1,
    // 			});
    // 		});
    // 	}
    // },
  }
};
</script>
